import React, { Fragment, useState } from 'react';
import { HeaderRow } from './HeaderRow';
import { CreateEmailDto } from '../../CreateEmailDto';
import { Control, UseFormRegister } from 'react-hook-form';
import { Subject } from './Subject';
import { To } from './To';
import { EmailRecipientCreatableMultiSelect } from '../../../../../../components/EmailRecipientCreatableMultiSelect';
import { User } from '../../../../../../entities/User';
import { SelectOption } from '../../../../../../components/Select';
import { Email } from '../../../../../../entities/Email';
import { EmailTemplate } from '../../../../../../entities/EmailTemplate';
import { EmailTemplates } from './EmailTemplates';

interface PropTypes {
  cc: SelectOption[];
  bcc: SelectOption[];
  replyToEmail?: Email;
  users: User[];
  emailTemplates: EmailTemplate[];
  emailTemplate?: EmailTemplate;
  control: Control<CreateEmailDto, any>;
  setEmailTemplate: (emailTemplate: EmailTemplate) => void;
  register: UseFormRegister<CreateEmailDto>;
  setCc: (cc: SelectOption[]) => void;
  setBcc: (cc: SelectOption[]) => void;
  setSubjectText: (text: string) => void;
}

export function EmailHeader(props: PropTypes) {
  const [ccEnabled, setCcEnabled] = useState(false);
  const [bccEnabled, setBccEnabled] = useState(false);

  return (
    <Fragment>
      <To
        bccEnabled={bccEnabled}
        ccEnabled={ccEnabled}
        register={props.register}
        control={props.control}
        setBccEnabled={setBccEnabled}
        setCcEnabled={setCcEnabled}
      />
      {ccEnabled && (
        <HeaderRow label='Cc'>
          <EmailRecipientCreatableMultiSelect
            placeholder={'Insert cc'}
            users={props.users}
            selected={props.cc}
            onChange={props.setCc}
          />
        </HeaderRow>
      )}
      {bccEnabled && (
        <HeaderRow label='Bcc'>
          <EmailRecipientCreatableMultiSelect
            placeholder={'Insert bcc'}
            users={props.users}
            selected={props.bcc}
            onChange={props.setBcc}
          />
        </HeaderRow>
      )}
      <EmailTemplates
        emailTemplates={props.emailTemplates}
        emailTemplate={props.emailTemplate}
        setEmailTemplate={props.setEmailTemplate}
      />
      <Subject
        replyToEmail={props.replyToEmail}
        emailTemplate={props.emailTemplate}
        control={props.control}
        setSubjectText={props.setSubjectText}
      />
    </Fragment>
  );
}
